module.exports = __webpack_public_path__ + "img/header_logo.c1d1b6c7.svg";